// extracted by mini-css-extract-plugin
export var deleteIcon = "_l1-5";
export var deleteOption = "_l1-3";
export var divider = "_l1-2";
export var downloadIcon = "_l1-4";
export var drawer = "_l1-0";
export var drawerFooter = "_l1-6";
export var drawerOpen = "_l1-1";
export var highlighted = "_l1-7";
export var lighterHighlight = "_l1-8";